export default "__VITE_ASSET__ME6Ha_we__"